import { CourseLevel } from "~/entity/Courses/model/shema";
import {
  EmployeeEducationProgramCourses,
  EmployeeEducationSetterParams,
} from "~/entity/Employee/model/schema";

interface ICollectDataToServerProps {
  positionIds: number[];
  instanceId: number;
  levelList: Omit<CourseLevel, "status" | "sequenceNumber">[];
  educationProgramCourses: Map<number, EmployeeEducationProgramCourses[]>;
  newLevelId?: number;
  newCourseId?: number;
  excludeCourseId?: number;
}

export const collectDataToServer = ({
  positionIds,
  instanceId,
  levelList,
  educationProgramCourses,
  newLevelId,
  newCourseId,
  excludeCourseId,
}: ICollectDataToServerProps): EmployeeEducationSetterParams => {
  return {
    instanceId,
    positionIds: (positionIds ?? []).map(Number),
    courseIds: ([] as number[]).concat(
      ...levelList.map(({ instanceId }) => {
        const currentCoursesList = educationProgramCourses.get(instanceId);
        return [
          ...(currentCoursesList ?? [])
            .filter((el) => el.course.instanceId !== excludeCourseId)
            .map(({ course }) => course.instanceId),
          ...(instanceId === newLevelId ? [newCourseId] : []),
        ];
      }),
    ),
  };
};
